// persistent-player.js
// Barba-compatible persistent audio player controller.

(function () {
  if (window.__persistentPlayerInit) return;
  window.__persistentPlayerInit = true;
  const pendingOpenQueue = Array.isArray(window.__persistentAudioPendingOpens)
    ? window.__persistentAudioPendingOpens
    : (window.__persistentAudioPendingOpens = []);
  if (!window.PersistentAudioPlayer || typeof window.PersistentAudioPlayer !== "object") {
    window.PersistentAudioPlayer = {};
  }
  if (typeof window.PersistentAudioPlayer.open !== "function") {
    window.PersistentAudioPlayer.open = function (detail) {
      pendingOpenQueue.push(detail || {});
      return true;
    };
  }
  let pendingBarbaScrollToTop = false;
  let pendingBarbaPopRestore = false;
  let pendingBarbaStandardNav = false;
  let activeBarbaNavigationHref = "";
  let activeBarbaNavigationStartedAt = 0;
  let activeBarbaNavigationTimer = null;

  function getBarbaScrollKey(url) {
    try {
      const absolute = new URL(url, window.location.href);
      absolute.hash = "";
      return "__barbaScroll::" + absolute.href;
    } catch (_) {
      return "__barbaScroll::" + String(url || window.location.href).split("#")[0];
    }
  }

  function storeCurrentScroll(url) {
    try {
      sessionStorage.setItem(
        getBarbaScrollKey(url || window.location.href),
        JSON.stringify({
          x: window.pageXOffset || window.scrollX || 0,
          y: window.pageYOffset || window.scrollY || 0
        })
      );
    } catch (_) {}
  }

  function readStoredScroll(url) {
    try {
      const raw = sessionStorage.getItem(getBarbaScrollKey(url || window.location.href));
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed.y !== "number") return null;
      return {
        x: typeof parsed.x === "number" ? parsed.x : 0,
        y: parsed.y
      };
    } catch (_) {
      return null;
    }
  }

  function applyScrollPosition(x, y) {
    try {
      window.scrollTo(x, y);
      document.documentElement.scrollLeft = x;
      document.documentElement.scrollTop = y;
      document.body.scrollLeft = x;
      document.body.scrollTop = y;
    } catch (_) {}
  }

  function getBarbaPageUrl(page, fallbackUrl) {
    if (page && page.url && typeof page.url.href === "string" && page.url.href) {
      return page.url.href;
    }
    return fallbackUrl || window.location.href;
  }

  function getNavigationUrl(rawUrl) {
    if (!rawUrl) return null;
    try {
      return new URL(rawUrl, window.location.href);
    } catch (_) {
      return null;
    }
  }

  function isSamePageHashLink(url) {
    if (!url || !url.hash) return false;
    return (
      url.origin === window.location.origin &&
      url.pathname === window.location.pathname &&
      url.search === window.location.search
    );
  }

  function isCurrentPageNoHashLink(url) {
    if (!url || url.hash) return false;
    return (
      url.origin === window.location.origin &&
      url.pathname === window.location.pathname &&
      url.search === window.location.search
    );
  }

  function isModifiedNavigationClick(event) {
    return !!(
      event &&
      (
        (typeof event.button === "number" && event.button !== 0) ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      )
    );
  }

  function isPlaceholderHref(rawHref) {
    const value = String(rawHref || "").trim();
    return !value || value === "#" || /^javascript:/i.test(value);
  }

  function isHeaderMenuNavigationLink(link) {
    if (!link || typeof link.closest !== "function") return false;
    if (!link.closest("[data-h2-menu]")) return false;
    if (link.closest("[data-newsletter-trigger], [data-global-form-trigger]")) return false;
    return !isPlaceholderHref(link.getAttribute("href") || link.href || "");
  }

  function isSecondHeaderNavigationLink(link) {
    if (!link || typeof link.closest !== "function") return false;
    if (!link.closest("[data-sh-root]")) return false;
    if (link.closest("[data-newsletter-trigger], [data-global-form-trigger]")) return false;
    if (link.hasAttribute("data-sh-desktop-toggle")) return false;
    if (link.hasAttribute("data-sh-drawer-parent-link") && !link.hasAttribute("data-sh-drawer-nav")) return false;
    return !isPlaceholderHref(link.getAttribute("href") || link.href || "");
  }

  function isSecondHeaderLink(el) {
    return !!(el && typeof el.closest === "function" && el.closest("[data-sh-root]"));
  }

  function isPersistentHeaderNavigationLink(link) {
    return isHeaderMenuNavigationLink(link) || isSecondHeaderNavigationLink(link);
  }

  function closePersistentMenusForNavigation(link) {
    if (typeof window.__h2CloseMenuForNavigation === "function") {
      try { window.__h2CloseMenuForNavigation(link); } catch (_) {}
    }
    if (typeof window.__shCloseMenuForNavigation === "function") {
      try { window.__shCloseMenuForNavigation(link); } catch (_) {}
    }
  }

  function closestFromTarget(target, selector) {
    if (!target) return null;
    const element = target.nodeType === 1 ? target : target.parentElement;
    if (!element || typeof element.closest !== "function") return null;
    return element.closest(selector);
  }

  function hasActiveBarbaNavigation(url) {
    if (!activeBarbaNavigationHref || !url) return false;
    return activeBarbaNavigationHref === url.href && (Date.now() - activeBarbaNavigationStartedAt) < 4000;
  }

  function markActiveBarbaNavigation(url) {
    activeBarbaNavigationHref = url && url.href ? url.href : "";
    activeBarbaNavigationStartedAt = Date.now();
    if (activeBarbaNavigationTimer) {
      clearTimeout(activeBarbaNavigationTimer);
      activeBarbaNavigationTimer = null;
    }
    activeBarbaNavigationTimer = window.setTimeout(() => {
      activeBarbaNavigationHref = "";
      activeBarbaNavigationStartedAt = 0;
      activeBarbaNavigationTimer = null;
    }, 4000);
  }

  function clearActiveBarbaNavigation() {
    activeBarbaNavigationHref = "";
    activeBarbaNavigationStartedAt = 0;
    if (activeBarbaNavigationTimer) {
      clearTimeout(activeBarbaNavigationTimer);
      activeBarbaNavigationTimer = null;
    }
  }

  function shouldBypassBarbaNavigation(href, el, options) {
    const opts = options || {};
    const ignoreNoBarba = !!opts.ignoreNoBarba;
    const rawHref = href || (el && typeof el.getAttribute === "function" && el.getAttribute("href")) || (el && el.href) || "";
    const url = getNavigationUrl(rawHref);
    if (!url) return true;
    if (el && typeof el.closest === "function") {
      if (el.target === "_blank" || el.hasAttribute("download")) return true;
      if (!ignoreNoBarba && el.closest("[data-no-barba], [data-global-form-trigger]")) return true;
      if (isSecondHeaderLink(el)) return true;
    }
    if (url.origin !== window.location.origin) return true;
    if (isSamePageHashLink(url)) return true;
    return (
      url.pathname.includes("/cart") ||
      url.pathname.includes("/checkout") ||
      url.pathname.includes("/account") ||
      url.pathname.includes("/password") ||
      url.pathname.includes("/policies") ||
      /^\/pages\/(?:get-on-the-map-form|host-form|submit-your-film-form|teach-form|perform-form|volunteer-form|fertile-substrate-form|vend-form|invisible-signals-form)(?:\/)?$/i.test(url.pathname)
    );
  }

  function shouldBypassBarbaLink(href, el) {
    return shouldBypassBarbaNavigation(href, el);
  }

  function navigateWithPersistentBarba(rawHref, options) {
    const opts = options || {};
    const link = opts.el || null;
    const url = getNavigationUrl(rawHref || (link && (link.getAttribute("href") || link.href)) || "");
    if (!url) return false;

    if (isCurrentPageNoHashLink(url)) {
      closePersistentMenusForNavigation(link);
      return false;
    }

    if (hasActiveBarbaNavigation(url)) return true;

    if (shouldBypassBarbaNavigation(url.href, link, opts)) return false;
    if (!window.barba || typeof window.barba.go !== "function") return false;

    closePersistentMenusForNavigation(link);
    pendingBarbaPopRestore = false;
    pendingBarbaScrollToTop = false;
    pendingBarbaStandardNav = true;
    markActiveBarbaNavigation(url);
    try {
      window.barba.go(url.href);
    } catch (_) {
      clearActiveBarbaNavigation();
      window.location.href = url.href;
    }
    return true;
  }

  if (!window.__persistentRouterOwnsNavigation) {
    window.__persistentBarbaNavigate = navigateWithPersistentBarba;
    window.__persistentShouldBypassBarbaLink = shouldBypassBarbaNavigation;
  }

  function bindPersistentBarbaLinkRouting() {
    if (!window.barba || typeof window.barba.go !== "function" || window.__persistentBarbaLinkRoutingBound) return;
    window.__persistentBarbaLinkRoutingBound = true;

    document.addEventListener("click", (event) => {
      if (isModifiedNavigationClick(event)) return;
      const link = closestFromTarget(event.target, "a[href]");
      if (!isPersistentHeaderNavigationLink(link)) return;

      const rawHref = link.getAttribute("href") || link.href || "";
      const currentUrl = getNavigationUrl(rawHref);
      if (currentUrl && isCurrentPageNoHashLink(currentUrl)) {
        closePersistentMenusForNavigation(link);
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
        return;
      }

      if (shouldBypassBarbaLink(rawHref, link)) return;

      if (navigateWithPersistentBarba(rawHref, { el: link })) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
      }
    }, true);

    document.addEventListener("click", (event) => {
      if (isModifiedNavigationClick(event)) return;
      const link = closestFromTarget(event.target, "a[href]");
      if (!link) return;
      if (event.defaultPrevented && !isPersistentHeaderNavigationLink(link)) return;

      const rawHref = link.getAttribute("href") || link.href || "";
      const url = getNavigationUrl(rawHref);
      if (!url) return;

      if (isCurrentPageNoHashLink(url)) {
        closePersistentMenusForNavigation(link);
        event.preventDefault();
        return;
      }

      if (shouldBypassBarbaLink(rawHref, link)) return;

      if (navigateWithPersistentBarba(url.href, { el: link })) {
        event.preventDefault();
        return;
      }
    });
  }

  function initPersistentPlayer() {
    if (window.__persistentPlayerReady) return;

  // =============================================
  // Barba init
  // =============================================
  if (!window.__persistentRouterOwnsNavigation && typeof barba !== "undefined") {
    try {
      if ("scrollRestoration" in window.history) {
        window.history.scrollRestoration = "manual";
      }
    } catch (_) {}

    window.addEventListener("popstate", () => {
      pendingBarbaPopRestore = true;
      pendingBarbaStandardNav = false;
      pendingBarbaScrollToTop = false;
    });

    function applyPendingScrollReset(targetUrl) {
      let targetX = 0;
      let targetY = 0;
      let shouldApply = false;
      const resolvedUrl = targetUrl || window.location.href;

      if (pendingBarbaPopRestore) {
        const stored = readStoredScroll(resolvedUrl);
        pendingBarbaPopRestore = false;
        if (stored) {
          targetX = stored.x;
          targetY = stored.y;
        }
        shouldApply = true;
      } else if (pendingBarbaScrollToTop || pendingBarbaStandardNav) {
        pendingBarbaScrollToTop = false;
        pendingBarbaStandardNav = false;
        shouldApply = true;
      }

      if (!shouldApply) return;

      applyScrollPosition(targetX, targetY);
      requestAnimationFrame(() => {
        applyScrollPosition(targetX, targetY);
        requestAnimationFrame(() => {
          applyScrollPosition(targetX, targetY);
        });
      });
      window.setTimeout(() => {
        applyScrollPosition(targetX, targetY);
      }, 80);
    }

    function dispatchSectionLifecycle(container, eventName, options) {
      if (!container) return;
      const sections = container.querySelectorAll('[id^="shopify-section-"]');
      const legacyOnly = !!(options && options.legacyOnly);
      sections.forEach((sectionEl) => {
        if (legacyOnly && !sectionEl.querySelector("[data-section-type]")) return;
        const rawId = sectionEl.getAttribute("id") || "";
        const sectionId = rawId.replace(/^shopify-section-/, "");
        if (!sectionId) return;
        try {
          sectionEl.dispatchEvent(new CustomEvent(eventName, {
            bubbles: true,
            detail: { sectionId }
          }));
        } catch (_) {}
      });
    }

    function executeContainerScripts(container) {
      if (!container) return;
      const scripts = Array.from(container.querySelectorAll("script"));
      scripts.forEach((oldScript) => {
        if (!oldScript || oldScript.src) return;
        const type = (oldScript.getAttribute("type") || "").trim();
        if (type && type !== "text/javascript" && type !== "application/javascript" && type !== "module") {
          return;
        }
        const newScript = document.createElement("script");
        Array.from(oldScript.attributes || []).forEach((attr) => {
          newScript.setAttribute(attr.name, attr.value);
        });
        newScript.textContent = oldScript.textContent || "";
        oldScript.replaceWith(newScript);
      });
    }

    function resetTransientUiLayers() {
      document.querySelectorAll('.tooltip').forEach((el) => {
        if (el && el.parentNode) el.parentNode.removeChild(el);
      });

      document.querySelectorAll('.gm-modal').forEach((modal) => {
        modal.classList.remove(
          'is-open',
          'is-closing',
          'is-closing-stage-1',
          'is-closing-stage-2',
          'is-closing-media',
          'is-closing-overlay',
          'is-opening-stage-1',
          'is-opening-overlay',
          'is-opening-media',
          'is-open-steady',
          'is-open-vb'
        );
        modal.hidden = true;
      });
      document.body.classList.remove('gm-lock');
      document.body.classList.remove('pap-info-scroll-locked');
      document.documentElement.classList.remove('pap-info-scroll-locked');

      document.querySelectorAll('.pswp').forEach((el) => {
        el.classList.remove(
          'pswp--open',
          'pswp--animate_opacity',
          'pswp--zoom-allowed',
          'pswp--zoomed-in',
          'pswp--dragging',
          'pswp--ui--hidden'
        );
        el.style.display = 'none';
      });
    }

    function runNavigationRecovery() {
      resetTransientUiLayers();
      try {
        Object.values(window.__relatedArticlesSliderInitFns || {}).forEach((fn) => {
          try { if (typeof fn === "function") fn(); } catch (_) {}
        });
        Object.values(window.__relatedArticlesSliderMotionInitFns || {}).forEach((fn) => {
          try { if (typeof fn === "function") fn(); } catch (_) {}
        });
        Object.values(window.__fffFilmPageInitFns || {}).forEach((fn) => {
          try { if (typeof fn === "function") fn(); } catch (_) {}
        });
        Object.values(window.__fffRelatedFilmsSliderInitFns || {}).forEach((fn) => {
          try { if (typeof fn === "function") fn(); } catch (_) {}
        });
        Object.values(window.__fffRelatedFilmsSliderMotionInitFns || {}).forEach((fn) => {
          try { if (typeof fn === "function") fn(); } catch (_) {}
        });
        Object.values(window.__splitImageHoverInitFns || {}).forEach((fn) => {
          try { if (typeof fn === "function") fn(); } catch (_) {}
        });
        Object.values(window.__splitImageHoverMotionInitFns || {}).forEach((fn) => {
          try { if (typeof fn === "function") fn(); } catch (_) {}
        });
        Object.values(window.__productTemplate9InitFns || {}).forEach((fn) => {
          try { if (typeof fn === "function") fn(); } catch (_) {}
        });
        Object.values(window.__productRecommendationsInitFns || {}).forEach((fn) => {
          try { if (typeof fn === "function") fn(); } catch (_) {}
        });
        Object.values(window.__dsvInitFns || {}).forEach((fn) => {
          try { if (typeof fn === "function") fn(); } catch (_) {}
        });
      } catch (_) {}
      try {
        if (window.AOS && typeof window.AOS.refreshHard === "function") {
          window.AOS.refreshHard();
        } else if (window.AOS && typeof window.AOS.refresh === "function") {
          window.AOS.refresh();
        }
      } catch (_) {}

      try {
        window.dispatchEvent(new CustomEvent("theme:barba:after-render"));
        window.dispatchEvent(new Event("resize"));
      } catch (_) {}
    }

    try {
      barba.init({
        debug: false,
        prevent: ({ href, el }) => shouldBypassBarbaLink(href, el),
        transitions: [{
          name: "fade",
          leave({ current }) {
            storeCurrentScroll(getBarbaPageUrl(current, window.location.href));
            if (!pendingBarbaPopRestore) {
              pendingBarbaStandardNav = true;
            }
            dispatchSectionLifecycle(current && current.container, "shopify:section:unload");
            return new Promise((resolve) => {
              current.container.style.opacity = 0;
              setTimeout(resolve, 500);
            });
          },
          enter({ next }) {
            next.container.style.opacity = 0;
            executeContainerScripts(next.container);
            dispatchSectionLifecycle(next.container, "shopify:section:load", { legacyOnly: true });
            resetTransientUiLayers();
            applyPendingScrollReset(getBarbaPageUrl(next, window.location.href));
            setTimeout(() => {
              next.container.style.transition = "opacity 0.5s ease";
              next.container.style.opacity = 1;
            }, 10);
          }
        }]
      });
    } catch (err) {
      console.warn("barba.init skipped:", err);
    }

    bindPersistentBarbaLinkRouting();

    if (barba.hooks && typeof barba.hooks.after === "function") {
      barba.hooks.after((data) => {
        clearActiveBarbaNavigation();
        applyPendingScrollReset(getBarbaPageUrl(data && data.next, window.location.href));
        requestAnimationFrame(() => {
          runNavigationRecovery();
          applyPendingScrollReset(getBarbaPageUrl(data && data.next, window.location.href));
        });
      });
    }
  } else if (!window.__persistentRouterOwnsNavigation) {
    console.warn("Barba.js is not loaded. Running player without transitions.");
  }

  // =============================================
  // Audio player
  // =============================================
  let player;
  let audio;
  let titleEl;
  let subtitleEl;
  let fullDescEl;
  let infoMainEl;
  let infoImageWrapEl;
  let infoImageEl;
  let playPauseBtn;
  let rewindBtn;
  let forwardBtn;
  let speedBtn;
  let speedInfoBtn;
  let muteBtn;
  let volumeInput;
  let volumeWrap;
  let volumePop;
  let descToggleBtn;
  let descPanel;
  let sourceLinkEl;
  let closeBtn;
  let progressInput;
  let legacyProgressWrap;
  let legacyProgressBar;
  let timeElapsedEl;
  let timeTotalEl;
  let legacyPlayTriangle;
  let legacyPauseBar1;
  let legacyPauseBar2;

  function refreshPlayerDom() {
    player = document.getElementById("persistent-player") || document.getElementById("persistent-audio-player");
    audio = document.getElementById("player-audio") || (function () {
      if (!player) return null;
      const el = document.createElement("audio");
      el.id = "player-audio";
      el.preload = "auto";
      player.appendChild(el);
      return el;
    })();
    titleEl = document.getElementById("player-title");
    subtitleEl = document.getElementById("player-subtitle");
    fullDescEl = document.getElementById("player-full-description");
    infoMainEl = document.getElementById("player-description-main");
    infoImageWrapEl = document.getElementById("player-info-image-wrap");
    infoImageEl = document.getElementById("player-info-image");
    playPauseBtn = document.getElementById("player-play-pause");
    rewindBtn = document.getElementById("player-rewind");
    forwardBtn = document.getElementById("player-forward");
    speedBtn = document.getElementById("player-speed");
    speedInfoBtn = document.getElementById("player-speed-info");
    muteBtn = document.getElementById("player-mute");
    volumeInput = document.getElementById("player-volume");
    volumeWrap = document.getElementById("player-volume-wrap");
    volumePop = document.getElementById("player-volume-pop");
    descToggleBtn = document.getElementById("player-description-toggle");
    descPanel = document.getElementById("player-description-panel");
    sourceLinkEl = document.getElementById("player-source-link");
    closeBtn = document.getElementById("player-close");
    progressInput = document.getElementById("player-progress");
    legacyProgressWrap = player ? player.querySelector(".progress-bar-wrapper") : null;
    legacyProgressBar = player ? player.querySelector(".progress-bar") : null;
    timeElapsedEl = player ? player.querySelector(".time-elapsed") : null;
    timeTotalEl = player ? player.querySelector(".time-total") : null;
    legacyPlayTriangle = document.getElementById("play-triangle");
    legacyPauseBar1 = document.getElementById("pause-bar1");
    legacyPauseBar2 = document.getElementById("pause-bar2");
    return !!(player && audio && playPauseBtn && closeBtn && (progressInput || legacyProgressWrap));
  }

  refreshPlayerDom();

  if (!player || !audio || !playPauseBtn || !closeBtn || (!progressInput && !legacyProgressWrap)) {
    console.warn("Persistent player DOM not found; skipping controller init.", {
      hasPlayer: !!player,
      hasAudio: !!audio,
      hasPlayPause: !!playPauseBtn,
      hasClose: !!closeBtn,
      hasProgressInput: !!progressInput,
      hasLegacyProgressWrap: !!legacyProgressWrap
    });
    return;
  }

  const skipSeconds = Math.max(1, parseInt(player.dataset.skipSeconds || "10", 10));
  const seekStepSeconds = Math.max(1, parseInt(player.dataset.seekStepSeconds || "5", 10));
  const defaultVolume = Math.min(100, Math.max(0, parseInt(player.dataset.defaultVolume || "90", 10)));
  const keyboardEnabled = player.dataset.keyboardShortcuts === "true";
  const speedOptions = String(player.dataset.speedOptions || "1,1.25,1.5,2")
    .split(",")
    .map((part) => parseFloat(part.trim()))
    .filter((value) => Number.isFinite(value) && value >= 0.5 && value <= 4);
  if (!speedOptions.length) speedOptions.push(1, 1.25, 1.5, 2);
  if (!speedOptions.includes(1)) speedOptions.unshift(1);

  let currentSpeedIndex = speedOptions.indexOf(1);
  let lastNonZeroVolume = defaultVolume > 0 ? defaultVolume : 70;
  let volumePopHideTimer = null;
  let activePlaylist = null;
  let activePlaylistIndex = -1;
  let activePlaylistContextId = "";
  const userAgent = navigator.userAgent || "";
  const isIOSDevice = /iPad|iPhone|iPod/.test(userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const isSafariEngine = /Safari/i.test(userAgent) && !/CriOS|FxiOS|EdgiOS|OPiOS/i.test(userAgent);
  const supportsProgrammaticVolume = !(isIOSDevice && isSafariEngine);

  if (player) player.classList.toggle("is-binary-volume", !supportsProgrammaticVolume);
  if (volumeWrap) volumeWrap.classList.toggle("is-binary-volume", !supportsProgrammaticVolume);

  function formatTime(seconds) {
    if (!Number.isFinite(seconds) || seconds < 0) return "0:00";
    const min = Math.floor(seconds / 60);
    const sec = Math.floor(seconds % 60).toString().padStart(2, "0");
    return `${min}:${sec}`;
  }

  function normalizeSourceUrl(rawUrl) {
    const fallback = window.location.href;
    const value = String(rawUrl || "").trim();
    if (!value) return fallback;
    try {
      return new URL(value, window.location.href).href;
    } catch (err) {
      return fallback;
    }
  }

  function normalizeMediaUrl(rawUrl) {
    const value = String(rawUrl || "").trim();
    if (!value) return "";
    try {
      return new URL(value, window.location.href).href;
    } catch (err) {
      return value;
    }
  }

  function mediaUrlsMatch(left, right) {
    const leftUrl = normalizeMediaUrl(left);
    const rightUrl = normalizeMediaUrl(right);
    return !!(leftUrl && rightUrl && leftUrl === rightUrl);
  }

  function setSourceLinkUI(payload) {
    if (!sourceLinkEl) return;
    const sourceUrl = normalizeSourceUrl(payload && payload.sourceUrl);
    const label = String((payload && payload.sourceLabel) || "Back to page").trim() || "Back to page";
    sourceLinkEl.href = sourceUrl;
    sourceLinkEl.textContent = label;
    sourceLinkEl.hidden = false;
    sourceLinkEl.setAttribute("aria-label", label);
    if (player) player.dataset.sourceUrl = sourceUrl;
  }

  function setInfoImageUI(payload) {
    if (!infoMainEl || !infoImageWrapEl || !infoImageEl) return;
    const rawUrl = String((payload && (payload.infoImageUrl || payload.imageUrl)) || "").trim();
    if (!rawUrl) {
      infoMainEl.classList.remove("has-image");
      infoImageWrapEl.hidden = true;
      infoImageEl.removeAttribute("src");
      infoImageEl.setAttribute("alt", "");
      return;
    }
    let imageUrl = rawUrl;
    try {
      imageUrl = new URL(rawUrl, window.location.href).href;
    } catch (err) {}
    const imageAlt = String((payload && payload.infoImageAlt) || (payload && payload.title) || "Track image").trim() || "Track image";
    infoImageEl.src = imageUrl;
    infoImageEl.alt = imageAlt;
    infoImageWrapEl.hidden = false;
    infoMainEl.classList.add("has-image");
  }

  function setPlayingUI(isPlaying) {
    if (playPauseBtn) {
      playPauseBtn.classList.toggle("is-playing", !!isPlaying);
      playPauseBtn.setAttribute("aria-label", isPlaying ? "Pause audio" : "Play audio");
    }
    if (legacyPlayTriangle) legacyPlayTriangle.style.display = isPlaying ? "none" : "";
    if (legacyPauseBar1) legacyPauseBar1.style.display = isPlaying ? "" : "none";
    if (legacyPauseBar2) legacyPauseBar2.style.display = isPlaying ? "" : "none";
  }

  function setProgressUI(percent) {
    const safe = Math.max(0, Math.min(100, Number.isFinite(percent) ? percent : 0));
    if (progressInput) progressInput.value = String(safe);
    if (legacyProgressBar) legacyProgressBar.style.width = `${safe}%`;
    if (legacyProgressWrap) legacyProgressWrap.setAttribute("aria-valuenow", String(Math.round(safe)));
    if (player) player.style.setProperty("--pap-progress", String(safe));
  }

  function resetProgressUI() {
    setProgressUI(0);
    if (timeElapsedEl) timeElapsedEl.textContent = "0:00";
    if (timeTotalEl) timeTotalEl.textContent = "0:00";
  }

  function closeDescriptionPanel() {
    player.classList.remove("description-open");
    if (descPanel) descPanel.setAttribute("aria-hidden", "true");
    if (descToggleBtn) descToggleBtn.setAttribute("aria-expanded", "false");
    setDescriptionScrollLock(false);
  }

  function openDescriptionPanel() {
    player.classList.add("description-open");
    if (descPanel) descPanel.setAttribute("aria-hidden", "false");
    if (descToggleBtn) descToggleBtn.setAttribute("aria-expanded", "true");
    setDescriptionScrollLock(true);
  }

  function setDescriptionScrollLock(locked) {
    document.documentElement.classList.toggle("pap-info-scroll-locked", !!locked);
    if (document.body) document.body.classList.toggle("pap-info-scroll-locked", !!locked);
  }

  function syncMuteButtonUI() {
    if (!muteBtn) return;
    const isMuted = !!audio.muted;
    muteBtn.classList.toggle("is-muted", isMuted);
    muteBtn.setAttribute("aria-label", supportsProgrammaticVolume ? "Audio volume" : (isMuted ? "Unmute audio" : "Mute audio"));
  }

  function setVolume(value) {
    const clamped = Math.max(0, Math.min(100, Math.round(value)));
    if (supportsProgrammaticVolume) {
      audio.volume = clamped / 100;
    }
    audio.muted = clamped === 0;
    if (clamped > 0) lastNonZeroVolume = clamped;
    if (volumeInput) volumeInput.value = String(clamped);
    if (player) player.style.setProperty("--pap-volume", String(clamped));
    syncMuteButtonUI();
    try { localStorage.setItem("persistent_audio_volume", String(clamped)); } catch (e) {}
  }

  function applySpeed(index) {
    currentSpeedIndex = (index + speedOptions.length) % speedOptions.length;
    const speed = speedOptions[currentSpeedIndex];
    audio.playbackRate = speed;
    if (speedBtn) speedBtn.textContent = `${speed}x`;
    if (speedInfoBtn) {
      speedInfoBtn.textContent = `${speed}x`;
      speedInfoBtn.setAttribute("aria-label", `Playback speed (${speed}x)`);
      speedInfoBtn.title = `${speed}x`;
    }
    try { localStorage.setItem("persistent_audio_speed", String(speed)); } catch (e) {}
  }

  function setCurrentTimeFromProgressValue(rawValue) {
    if (!audio.duration) return;
    const pct = Math.max(0, Math.min(100, parseFloat(rawValue || "0"))) / 100;
    audio.currentTime = pct * audio.duration;
  }

  function clearVolumePopHideTimer() {
    if (!volumePopHideTimer) return;
    clearTimeout(volumePopHideTimer);
    volumePopHideTimer = null;
  }

  function openVolumePop() {
    if (!volumePop) return;
    clearVolumePopHideTimer();
    if (volumePop.hidden) {
      volumePop.hidden = false;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (!volumePop) return;
          volumePop.classList.add("is-open");
        });
      });
      return;
    }
    volumePop.classList.add("is-open");
  }

  function closeVolumePop(immediate) {
    if (!volumePop) return;
    clearVolumePopHideTimer();
    volumePop.classList.remove("is-open");
    if (immediate) {
      volumePop.hidden = true;
      return;
    }
    volumePopHideTimer = setTimeout(() => {
      if (!volumePop || volumePop.classList.contains("is-open")) return;
      volumePop.hidden = true;
      volumePopHideTimer = null;
    }, 900);
  }

  function scheduleCloseVolumePop(delayMs) {
    if (!volumePop || volumePop.hidden) return;
    clearVolumePopHideTimer();
    volumePopHideTimer = setTimeout(() => {
      if (!volumePop) return;
      closeVolumePop();
    }, Math.max(0, delayMs || 840));
  }

  function clearActivePlaylist() {
    activePlaylist = null;
    activePlaylistIndex = -1;
    activePlaylistContextId = "";
  }

  function bindOnce(el, key, type, handler) {
    if (!el || el[key]) return;
    el[key] = true;
    el.addEventListener(type, handler);
  }

  function bindDescriptionScrollContainment() {
    if (!descPanel || !fullDescEl || descPanel.__papScrollContainmentBound) return;
    descPanel.__papScrollContainmentBound = true;
    let lastTouchY = null;

    function isPanelOpen() {
      return !!(player && player.classList.contains("description-open"));
    }

    function getScrollState() {
      const maxScroll = Math.max(0, fullDescEl.scrollHeight - fullDescEl.clientHeight);
      const scrollTop = fullDescEl.scrollTop;
      return {
        maxScroll,
        atTop: scrollTop <= 0,
        atBottom: scrollTop >= maxScroll - 1
      };
    }

    function shouldContain(deltaY) {
      if (!isPanelOpen()) return false;
      const state = getScrollState();
      if (state.maxScroll <= 0) return true;
      return (deltaY < 0 && state.atTop) || (deltaY > 0 && state.atBottom);
    }

    function canScrollFromTarget(target) {
      return !!(fullDescEl && target && fullDescEl.contains(target));
    }

    descPanel.addEventListener("wheel", (event) => {
      if (!isPanelOpen()) return;
      if (!descPanel.contains(event.target)) return;
      event.stopPropagation();
      if (!canScrollFromTarget(event.target) || shouldContain(event.deltaY || 0)) {
        event.preventDefault();
      }
    }, { passive: false });

    descPanel.addEventListener("touchstart", (event) => {
      if (!isPanelOpen() || !event.touches || !event.touches.length || !descPanel.contains(event.target)) return;
      lastTouchY = event.touches[0].clientY;
    }, { passive: true });

    descPanel.addEventListener("touchmove", (event) => {
      if (!isPanelOpen() || !event.touches || !event.touches.length || lastTouchY === null) return;
      const currentY = event.touches[0].clientY;
      const deltaY = lastTouchY - currentY;
      lastTouchY = currentY;
      event.stopPropagation();
      if (!canScrollFromTarget(event.target) || shouldContain(deltaY)) {
        event.preventDefault();
      }
    }, { passive: false });

    descPanel.addEventListener("touchend", () => {
      lastTouchY = null;
    }, { passive: true });

    descPanel.addEventListener("touchcancel", () => {
      lastTouchY = null;
    }, { passive: true });
  }

  function bindCurrentPlayerControls() {
    if (!refreshPlayerDom()) return false;

    bindOnce(playPauseBtn, "__papPlayBound", "click", () => {
      if (!audio.src) return;
      if (audio.paused || audio.ended) {
        audio.play().catch((err) => console.log("Play error:", err));
      } else {
        audio.pause();
      }
    });
    bindOnce(rewindBtn, "__papRewindBound", "click", () => {
      if (!audio.src) return;
      audio.currentTime = Math.max(0, audio.currentTime - skipSeconds);
    });
    bindOnce(forwardBtn, "__papForwardBound", "click", () => {
      if (!audio.src || !audio.duration) return;
      audio.currentTime = Math.min(audio.duration, audio.currentTime + skipSeconds);
    });
    bindOnce(speedBtn, "__papSpeedBound", "click", () => {
      applySpeed(currentSpeedIndex + 1);
    });
    bindOnce(speedInfoBtn, "__papSpeedInfoBound", "click", () => {
      applySpeed(currentSpeedIndex + 1);
    });
    bindOnce(muteBtn, "__papMuteBound", "click", (event) => {
      event.stopPropagation();
      if (!supportsProgrammaticVolume) {
        const nextMuted = !audio.muted;
        audio.muted = nextMuted;
        if (volumeInput) volumeInput.value = nextMuted ? "0" : String(lastNonZeroVolume);
        if (player) player.style.setProperty("--pap-volume", nextMuted ? "0" : String(lastNonZeroVolume));
        syncMuteButtonUI();
        closeVolumePop(true);
        return;
      }
      const isOpen = !!(volumePop && !volumePop.hidden && volumePop.classList.contains("is-open"));
      if (isOpen) closeVolumePop();
      else openVolumePop();
    });
    if (volumeInput && !volumeInput.__papVolumeStateBound) {
      volumeInput.__papVolumeStateBound = true;
      if (!supportsProgrammaticVolume) {
        volumeInput.disabled = true;
        volumeInput.setAttribute("aria-hidden", "true");
        volumeInput.tabIndex = -1;
      }
    }
    bindOnce(volumeInput, "__papVolumeInputBound", "input", () => {
      if (!supportsProgrammaticVolume) return;
      setVolume(parseInt(volumeInput.value || "0", 10));
    });
    bindOnce(volumeWrap, "__papVolumeWrapBound", "click", (event) => {
      if (!supportsProgrammaticVolume) return;
      if (event.target && event.target === volumeWrap) {
        event.stopPropagation();
        if (volumePop.hidden || !volumePop.classList.contains("is-open")) {
          openVolumePop();
        } else {
          closeVolumePop();
        }
      }
    });
    bindOnce(volumePop, "__papVolumePopBound", "click", (event) => event.stopPropagation());
    bindDescriptionScrollContainment();
    bindOnce(descToggleBtn, "__papDescriptionBound", "click", () => {
      const open = !player.classList.contains("description-open");
      if (open) openDescriptionPanel();
      else closeDescriptionPanel();
    });
    bindOnce(progressInput, "__papProgressInputBound", "input", () => {
      if (!audio.duration) return;
      setCurrentTimeFromProgressValue(progressInput.value);
      const pct = Math.max(0, Math.min(100, parseFloat(progressInput.value || "0")));
      setProgressUI(pct);
      if (timeElapsedEl) timeElapsedEl.textContent = formatTime((pct / 100) * audio.duration);
    });
    bindOnce(progressInput, "__papProgressChangeBound", "change", () => {
      if (!audio.duration) return;
      setCurrentTimeFromProgressValue(progressInput.value);
    });
    if (!progressInput && legacyProgressWrap) {
      const setProgressFromPointer = (clientX) => {
        if (!audio.duration) return;
        const rect = legacyProgressWrap.getBoundingClientRect();
        if (!rect.width) return;
        const pct = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
        audio.currentTime = pct * audio.duration;
        setProgressUI(pct * 100);
        if (timeElapsedEl) timeElapsedEl.textContent = formatTime(audio.currentTime);
      };
      bindOnce(legacyProgressWrap, "__papProgressClickBound", "click", (event) => {
        setProgressFromPointer(event.clientX);
      });
      bindOnce(legacyProgressWrap, "__papProgressKeyBound", "keydown", (event) => {
        if (!audio.duration) return;
        if (event.key !== "ArrowLeft" && event.key !== "ArrowRight" && event.key !== "Home" && event.key !== "End") return;
        event.preventDefault();
        if (event.key === "Home") {
          audio.currentTime = 0;
        } else if (event.key === "End") {
          audio.currentTime = audio.duration;
        } else if (event.key === "ArrowLeft") {
          audio.currentTime = Math.max(0, audio.currentTime - seekStepSeconds);
        } else if (event.key === "ArrowRight") {
          audio.currentTime = Math.min(audio.duration, audio.currentTime + seekStepSeconds);
        }
        setProgressUI((audio.currentTime / audio.duration) * 100);
      });
    }
    bindOnce(closeBtn, "__papCloseBound", "click", closePlayer);
    if (audio && !audio.__papAudioEventsBound) {
      audio.__papAudioEventsBound = true;
      audio.addEventListener("play", () => {
        setPlayingUI(true);
      });
      audio.addEventListener("pause", () => {
        setPlayingUI(false);
      });
      audio.addEventListener("ended", () => {
        const nextPayload = getNextPlaylistPayload();
        if (nextPayload) {
          if (openFromPayload(nextPayload)) return;
        }
        setPlayingUI(false);
        resetProgressUI();
      });
      audio.addEventListener("timeupdate", () => {
        if (!audio.duration || Number.isNaN(audio.duration)) return;
        const progressPercent = (audio.currentTime / audio.duration) * 100;
        setProgressUI(progressPercent);
        if (timeElapsedEl) timeElapsedEl.textContent = formatTime(audio.currentTime);
        if (timeTotalEl) timeTotalEl.textContent = formatTime(audio.duration);
      });
      audio.addEventListener("loadedmetadata", () => {
        if (timeTotalEl) timeTotalEl.textContent = formatTime(audio.duration);
        if (timeElapsedEl) timeElapsedEl.textContent = "0:00";
        setProgressUI(0);
      });
    }
    return true;
  }

  function normalizeOpenPayload(raw) {
    const payload = raw || {};
    const autoAdvance = !!(payload.autoAdvance || payload.playlistAutoAdvance);
    return {
      audioUrl: String(payload.audioUrl || payload.url || "").trim(),
      title: payload.title || "",
      infoTitle: payload.infoTitle || payload.title || "",
      description: payload.description || payload.desc || "",
      fullDescription: payload.fullDescription || payload.fullDesc || payload.description || payload.desc || "",
      fullDescriptionHtml: payload.fullDescriptionHtml || payload.fullDescHtml || "",
      infoImageUrl: payload.infoImageUrl || payload.imageUrl || "",
      infoImageAlt: payload.infoImageAlt || payload.title || "Track image",
      sourceUrl: payload.sourceUrl || window.location.href,
      sourceLabel: payload.sourceLabel || "Back to page",
      autoPlay: !!payload.autoPlay && autoAdvance,
      previewOnly: !!payload.previewOnly,
      openInfo: !!payload.openInfo
    };
  }

  function syncPlaylistFromPayload(rawPayload, currentAudioUrl) {
    const payload = rawPayload || {};
    const incoming = Array.isArray(payload.playlist) ? payload.playlist : null;
    if (!incoming || !incoming.length) {
      clearActivePlaylist();
      return;
    }

    const normalizedPlaylist = incoming
      .map((entry) => normalizeOpenPayload(entry))
      .filter((entry) => !!entry.audioUrl);
    if (!normalizedPlaylist.length) {
      clearActivePlaylist();
      return;
    }

    let index = parseInt(payload.playlistIndex, 10);
    if (!Number.isFinite(index) || index < 0 || index >= normalizedPlaylist.length) {
      index = normalizedPlaylist.findIndex((entry) => entry.audioUrl === currentAudioUrl);
    }
    if (!Number.isFinite(index) || index < 0 || index >= normalizedPlaylist.length) {
      clearActivePlaylist();
      return;
    }

    activePlaylist = normalizedPlaylist;
    activePlaylistIndex = index;
    activePlaylistContextId = String(payload.playlistContextId || "");
  }

  function getNextPlaylistPayload() {
    if (!Array.isArray(activePlaylist) || !activePlaylist.length) return null;
    const nextIndex = activePlaylistIndex + 1;
    if (nextIndex < 0 || nextIndex >= activePlaylist.length) return null;
    const next = activePlaylist[nextIndex];
    if (!next || !next.audioUrl) return null;
    return Object.assign({}, next, {
      playlist: activePlaylist,
      playlistIndex: nextIndex,
      playlistContextId: activePlaylistContextId,
      autoAdvance: true,
      autoPlay: true
    });
  }

  function getTriggerPayload(trigger) {
    if (!trigger) return null;
    const url = trigger.dataset ? trigger.dataset.audioUrl : "";
    if (!url) return;

    const fallbackTitleNode = trigger.querySelector ? trigger.querySelector(".audio-title, h1, h2, h3, h4") : null;
    const fallbackDescNode = trigger.querySelector ? trigger.querySelector(".audio-desc, p") : null;
    const title = (trigger.dataset ? trigger.dataset.title : "") || (fallbackTitleNode ? fallbackTitleNode.textContent.trim() : "") || "Now Playing";
    const infoTitle = (trigger.dataset ? trigger.dataset.infoTitle : "") || title;
    const desc = (trigger.dataset ? trigger.dataset.desc : "") || (fallbackDescNode ? fallbackDescNode.textContent.trim() : "") || "";
    const fullDesc = (trigger.dataset ? trigger.dataset.fullDescription : "") || desc || "";
    const template = trigger.querySelector ? trigger.querySelector("[data-audio-info-html]") : null;
    const fullDescHtml = (trigger.dataset ? trigger.dataset.fullDescriptionHtml : "") || (template ? template.innerHTML : "");
    const infoImageUrl = (trigger.dataset ? trigger.dataset.infoImageUrl : "") || "";
    const infoImageAlt = (trigger.dataset ? trigger.dataset.infoImageAlt : "") || title || "";
    const sourceUrl = (trigger.dataset ? trigger.dataset.sourceUrl : "") || window.location.href;
    const sourceLabel = (trigger.dataset ? trigger.dataset.sourceLabel : "") || "Back to page";
    return { url, title, infoTitle, desc, fullDesc, fullDescHtml, infoImageUrl, infoImageAlt, sourceUrl, sourceLabel };
  }

  function setTrackFromTrigger(trigger, options) {
    if (!refreshPlayerDom()) return;
    bindCurrentPlayerControls();
    const payload = getTriggerPayload(trigger);
    if (!payload) return;
    const autoPlay = !!(options && options.autoPlay);

    if (titleEl) titleEl.textContent = payload.infoTitle || payload.title;
    if (subtitleEl) subtitleEl.textContent = payload.desc;
    if (fullDescEl) {
      if (payload.fullDescHtml) {
        fullDescEl.innerHTML = payload.fullDescHtml;
      } else {
        fullDescEl.textContent = payload.fullDesc;
      }
    }
    setInfoImageUI(payload);
    setSourceLinkUI(payload);

    const resolvedCurrent = audio.currentSrc || audio.src || "";
    const sameTrack = mediaUrlsMatch(resolvedCurrent, payload.url);
    const wasPlaying = !!(audio && !audio.paused && !audio.ended);
    audio.preload = "auto";
    audio.setAttribute("preload", audio.preload);

    if (!sameTrack) {
      audio.pause();
      resetProgressUI();
      audio.src = payload.url;
      audio.load();
    } else if (!wasPlaying && !autoPlay) {
      audio.currentTime = 0;
      resetProgressUI();
      if (audio.readyState < 3) {
        try { audio.load(); } catch (_) {}
      }
    }

    player.classList.add("visible");
    closeDescriptionPanel();
    closeVolumePop(true);
    setPlayingUI(sameTrack && wasPlaying);

    if (autoPlay) {
      const attemptAutoPlay = () => {
        audio.play().catch((err) => {
          console.log("Play error:", err);
        });
      };
      if (sameTrack) {
        attemptAutoPlay();
      } else {
        const onReady = () => {
          audio.removeEventListener("canplay", onReady);
          audio.removeEventListener("loadedmetadata", onReady);
          attemptAutoPlay();
        };
        audio.addEventListener("canplay", onReady);
        audio.addEventListener("loadedmetadata", onReady);
        attemptAutoPlay();
      }
    }
  }

  function setPreviewFromPayload(payload) {
    if (!refreshPlayerDom()) return false;
    bindCurrentPlayerControls();
    const normalized = payload || {};

    if (titleEl) titleEl.textContent = normalized.infoTitle || normalized.title;
    if (subtitleEl) subtitleEl.textContent = normalized.description || "";
    if (fullDescEl) {
      if (normalized.fullDescriptionHtml) {
        fullDescEl.innerHTML = normalized.fullDescriptionHtml;
      } else {
        fullDescEl.textContent = normalized.fullDescription || "";
      }
    }
    setInfoImageUI(normalized);
    setSourceLinkUI(normalized);

    const hasCurrentAudio = !!(audio.currentSrc || audio.src);
    const wasPlaying = hasCurrentAudio && !audio.paused && !audio.ended;
    if (!hasCurrentAudio) {
      resetProgressUI();
    }
    player.classList.add("visible");
    closeDescriptionPanel();
    closeVolumePop(true);
    setPlayingUI(wasPlaying);
    return true;
  }

  function openFromPayload(detail) {
    if (!refreshPlayerDom()) return false;
    bindCurrentPlayerControls();
    const payload = detail || {};
    const normalized = normalizeOpenPayload(payload);
    if (!normalized.audioUrl) {
      if (!normalized.previewOnly) return false;
      const didPreview = setPreviewFromPayload(normalized);
      if (didPreview && normalized.openInfo) openDescriptionPanel();
      return didPreview;
    }
    syncPlaylistFromPayload(payload, normalized.audioUrl);
    const proxy = {
      dataset: {
        audioUrl: normalized.audioUrl,
        title: normalized.title,
        infoTitle: normalized.infoTitle,
        desc: normalized.description,
        fullDescription: normalized.fullDescription,
        fullDescriptionHtml: normalized.fullDescriptionHtml,
        infoImageUrl: normalized.infoImageUrl,
        infoImageAlt: normalized.infoImageAlt,
        sourceUrl: normalized.sourceUrl,
        sourceLabel: normalized.sourceLabel
      }
    };
    setTrackFromTrigger(proxy, { autoPlay: normalized.autoPlay });
    if (normalized.openInfo) openDescriptionPanel();
    return true;
  }

  document.addEventListener("click", (event) => {
    const button = event.target && event.target.closest ? event.target.closest("[data-pap-add-product]") : null;
    refreshPlayerDom();
    if (!button || !player || !player.contains(button)) return;
    const variantId = button.getAttribute("data-variant-id");
    if (!variantId || button.disabled) return;
    event.preventDefault();
    const originalText = button.getAttribute("data-original-text") || button.textContent || "Add to cart";
    button.setAttribute("data-original-text", originalText);
    button.disabled = true;
    button.textContent = "ADDING...";
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then((response) => {
        if (!response.ok) throw new Error("Add to cart failed");
        return response.json();
      })
      .then(() => {
        button.textContent = "ADDED!";
        if (window.theme && window.theme.miniCart) {
          try {
            if (typeof window.theme.miniCart.updateElements === "function") window.theme.miniCart.updateElements();
          } catch (_) {}
          try {
            if (typeof window.theme.miniCart.generateCart === "function") window.theme.miniCart.generateCart();
          } catch (_) {}
        }
        try { document.dispatchEvent(new CustomEvent("theme:cart:refresh", { bubbles: true })); } catch (_) {}
        try { document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true })); } catch (_) {}
        try { window.dispatchEvent(new CustomEvent("cart:refresh")); } catch (_) {}
        try { window.dispatchEvent(new CustomEvent("cart:open")); } catch (_) {}
        try {
          fetch("/cart.js", { headers: { "Accept": "application/json" } })
            .then((cartResponse) => cartResponse.ok ? cartResponse.json() : null)
            .then((cart) => {
              if (!cart) return;
              document.querySelectorAll(".js-cart-count").forEach((node) => {
                node.textContent = String(cart.item_count || 0);
              });
              document.querySelectorAll(".header-cart-link, .js-toggle-cart").forEach((node) => {
                node.setAttribute("data-cart-count", String(cart.item_count || 0));
              });
            })
            .catch(() => {});
        } catch (_) {}
        window.setTimeout(() => {
          button.disabled = false;
          button.textContent = originalText;
        }, 1400);
      })
      .catch(() => {
        button.disabled = false;
        button.textContent = originalText;
      });
  });

  document.addEventListener("click", (event) => {
    if (!volumeWrap || !volumePop || volumePop.hidden) return;
    if (volumeWrap.contains(event.target)) return;
    closeVolumePop();
  });

  function closePlayer() {
    if (!refreshPlayerDom()) return;
    audio.pause();
    audio.currentTime = 0;
    clearActivePlaylist();
    player.classList.remove("visible");
    closeDescriptionPanel();
    closeVolumePop(true);
    resetProgressUI();
    setPlayingUI(false);
  }

  window.PersistentAudioPlayer.open = openFromPayload;
  window.PersistentAudioPlayer.close = closePlayer;

  bindCurrentPlayerControls();

  if (keyboardEnabled) {
    document.addEventListener("keydown", (e) => {
      if (!player.classList.contains("visible")) return;
      const target = e.target;
      if (target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable)) return;

      if (e.code === "Space") {
        e.preventDefault();
        playPauseBtn.click();
      } else if (e.key === "ArrowRight") {
        e.preventDefault();
        audio.currentTime = Math.min((audio.duration || Infinity), audio.currentTime + seekStepSeconds);
      } else if (e.key === "ArrowLeft") {
        e.preventDefault();
        audio.currentTime = Math.max(0, audio.currentTime - seekStepSeconds);
      } else if (e.key.toLowerCase() === "m" && muteBtn) {
        e.preventDefault();
        muteBtn.click();
      }
    });
  }

  document.addEventListener("persistent-audio:play", (event) => {
    openFromPayload(event.detail || {});
  });

  // bootstrap
  (function bootstrap() {
    let savedVolume = defaultVolume;
    let savedSpeed = 1;
    try {
      const rawVol = localStorage.getItem("persistent_audio_volume");
      const rawSpeed = localStorage.getItem("persistent_audio_speed");
      if (rawVol !== null) savedVolume = parseInt(rawVol, 10);
      if (rawSpeed !== null) savedSpeed = parseFloat(rawSpeed);
    } catch (e) {}

    const rememberedVolume = Number.isFinite(savedVolume) ? savedVolume : defaultVolume;
    const initialVolume = Number.isFinite(defaultVolume) ? defaultVolume : rememberedVolume;
    setVolume(initialVolume);
    if (!supportsProgrammaticVolume) {
      closeVolumePop(true);
    }
    const savedSpeedIndex = speedOptions.indexOf(savedSpeed);
    applySpeed(savedSpeedIndex >= 0 ? savedSpeedIndex : currentSpeedIndex);
    setPlayingUI(false);

    window.__persistentPlayerReady = true;
    window.PersistentAudioPlayer.isReady = true;

    if (pendingOpenQueue.length) {
      const queuedOpens = pendingOpenQueue.splice(0, pendingOpenQueue.length);
      queuedOpens.forEach((detail) => {
        openFromPayload(detail);
      });
    }
  })();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPersistentPlayer);
  } else {
    initPersistentPlayer();
  }
})();
